<template>
  <div v-if="CompanyItems.ragulationFlag">
    <Breadcrumbs
      page_title="companypoliciesandregulations"
      :items="breadcrumbs"
    />
    <v-card class="mx-3 my-5" style="border-radius: 16px">
      <v-row>
        <v-col cols="12" lg="12" md="12" sm="12">
          <p class="ml-5">{{ CompanyItems.companyName }}</p>
          <p class="ml-5">{{ $t("date") }} : {{ currentDate }}</p>
        </v-col>
      </v-row>

    
        <v-textarea
          v-model="CompanyItems.ragulationText"
          auto-grow
          readonly
          tabindex="-1"
          rows="1"
          hide-details
          class="custom-textarea no-border-textarea"
        />
    </v-card>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#FAA91B"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    const now = new Date();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const yyyy = now.getFullYear();
    return {
      currentDate: `${mm}-${dd}-${yyyy}`,

      successDialog: false,
      status: true,
      content: "",
      loading: false,
      breadcrumbs: [
        {
          text: "companypoliciesandregulations",
        },
      ],
      CompanyItems: {
        companyName: "",
        ragulationFlag: false,
        ragulationText: "",
      },
    };
  },
  mounted() {
    this.GetCompanyRegulation();
  },
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      },
    },
  },
  methods: {
    async GetCompanyRegulation() {
      let that = this;
      that.loading = true;

      let companyID = localStorage.getItem("companyID");

      await axios
        .get(`${that.web_url}Company/GetCompanyRagulation`, {
          params: {
            id: companyID,
          },
        })
        .then(function (response) {
          if (response.data.status === 0) {
            that.CompanyItems = response.data.data;
          }
        })

        .catch(function (err) {
          that.loading = false;
          throw err;
        });

      that.loading = false;
    },

    Close() {
      this.successDialog = false;
    },
    cancelAdd() {},
    submit() {},
  },
};
</script>
<style scoped>
::v-deep(.v-text-field > .v-input__control > .v-input__slot:after) {
  display: none !important;
}
::v-deep(.v-text-field > .v-input__control > .v-input__slot::before) {
  display: none !important;
}

.custom-textarea ::v-deep textarea {
  margin-top: 3%;
  padding-bottom: 2%;
  padding-left: 3%;
}


.btnfont-style {
  font-size: 16px;
  border-radius: 8px;
}
.noti-icon .v-icon {
  color: #424242 !important;
}
.title_style {
  color: #000000;
  font-size: 22px;
}
</style>
